import { render, staticRenderFns } from "./LogList.vue?vue&type=template&id=a887a900&scoped=true"
import script from "./LogList.vue?vue&type=script&lang=js"
export * from "./LogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a887a900",
  null
  
)

export default component.exports